import { render, staticRenderFns } from "./BillableCloseDialog.vue?vue&type=template&id=b1828d28&scoped=true"
import script from "./BillableCloseDialog.vue?vue&type=script&lang=js"
export * from "./BillableCloseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1828d28",
  null
  
)

export default component.exports